"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stateMutator = exports.NumberMapMutator = void 0;
var ifn_1 = require("./ifn");
Object.defineProperty(exports, "NumberMapMutator", { enumerable: true, get: function () { return ifn_1.NumberMapMutator; } });
Object.defineProperty(exports, "stateMutator", { enumerable: true, get: function () { return ifn_1.stateMutator; } });
